import React, { useEffect, useState } from 'react';
import {
  deleteSinglePendingApplicantAction,
  getPendingApplicantsAction,
} from '../../../../modules/applicantsModearion/applicants/Actions';

import {
  applicantsListSelector,
  pendingApplicantsIsLoadingSelector,
  applicantsCountSelector,
} from /*   searchValueSelector,
 */ '../../../../modules/applicantsModearion/applicants/Selectors';

import { connect } from 'react-redux';

import List from '../../../../components/Lists/List';
import ListItem from '../../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import getLangData from '../../../../utils/getLangData';

const ApplicantsList = (props) => {
  const {
    applicants,
    applicantsIsLoading,
    getApplicants,
    deleteApplicant,
    /*     searchValue,
     */ applicantsCount,
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const lang = getLangData().general_words
  useEffect(() => {
    getApplicants({ size, offset /* , searchTerm: searchValue */ });
  }, [getApplicants /* , searchValue */]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (applicants.length >= applicantsCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getApplicants({
      size,
      offset: applicants.length /* , searchTerm: searchValue */,
    });
  };

  //
  const dataLength =
    applicants.length <= applicantsCount ? applicants.length : applicantsCount;
  return (
    <InfiniteScroll dataLength={dataLength} hasMore={hasMore} next={fetchMore}>
      <List
        isLoading={applicantsIsLoading}
        header={{ items: [lang.business_name], actions: ['view', 'Delete'] }}
        items={applicants}
      >
        {' '}
        <div className="table row block--container my-5">
          <table className="table">
            <tbody>
              {applicants.length > 0 &&
                applicants.map((data) => {
                  const { _id, name } = data
                  return (
                    <ListItem
                      /*               type={"multi"}
              data={[businessName]} */
                      name={name}
                      key={_id}
                      viewLink={`/applicants-moderation/applicants/${_id}`}
                      onDelete={() => deleteApplicant(_id)}
                    />
                  );
                })}
            </tbody>
          </table>
        </div>
      </List>{' '}
    </InfiniteScroll>
  );
};

const mapStateToProps = (state) => ({
  applicants: applicantsListSelector(state),
  applicantsIsLoading: pendingApplicantsIsLoadingSelector(state),
  applicantsCount: applicantsCountSelector(state),
  /*   searchValue: searchValueSelector(state),
   */
});

export default connect(mapStateToProps, {
  getApplicants: getPendingApplicantsAction,
  deleteApplicant: deleteSinglePendingApplicantAction,
})(ApplicantsList);
